var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { colors } from '../../styleguide/styles/colors';
//the opacity is set through 7F
var ModalBackground = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100%;\n  z-index: 50;\n  background-color: ", "7F;\n  justify-content: center;\n"], ["\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100%;\n  z-index: 50;\n  background-color: ", "7F;\n  justify-content: center;\n"])), colors.primary);
export default ModalBackground;
var templateObject_1;
